/**
 * Created by Administrator on 2019/1/2.
 */
export default {
    state: {
      //state
      isOnline: false,
      ydjClient: null,
      standardAnswer:[],
      stepNum: 0,
      testPaperList:[],
      isContinue: false,
      coverObj:{
        isCover: false,
        coverData:''
      },
      selectedSubjectId: '',
      scanSubjectId: '',
      scanType: ''
    },
    mutations: {
      set_isOnline(state, data) {
        //这里的state对应着上面这个state
        state.isOnline = data;
        //你还可以在这里执行其他的操作改变state
      },
      set_ydjClient(state, data) {
        //这里的state对应着上面这个state
        state.ydjClient = data;
        //你还可以在这里执行其他的操作改变state
      },
      set_standardAnswer(state, data) {
        //这里的state对应着上面这个state
        state.standardAnswer.push(data);
        //你还可以在这里执行其他的操作改变state
      },
      clear_standardAnswer(state, data) {
        //这里的state对应着上面这个state
        state.standardAnswer = [];
        //你还可以在这里执行其他的操作改变state
      },
      set_stepNum(state, data) {
        //这里的state对应着上面这个state
        state.stepNum = data;
        //你还可以在这里执行其他的操作改变state
      },
      set_testPaperList(state, data) {
        //这里的state对应着上面这个state
        state.testPaperList.push(data);
        //你还可以在这里执行其他的操作改变state
      },
      clear_testPaperList(state, data) {
        //这里的state对应着上面这个state
        state.testPaperList = [];
        //你还可以在这里执行其他的操作改变state
      },
      set_isContinue(state, data) {
        //这里的state对应着上面这个state
        state.isContinue = data;
        //你还可以在这里执行其他的操作改变state
      },
      set_isCover(state, data) {
        //这里的state对应着上面这个state
        state.coverObj = data;
        //你还可以在这里执行其他的操作改变state
      },
      set_coverData(state, data) {
        //这里的state对应着上面这个state
        state.coverData = data;
        //你还可以在这里执行其他的操作改变state
      },
      set_selectedSubjectId(state, data) {
        state.selectedSubjectId = data
      },
      set_scanSubjectId(state, data) {
        state.scanSubjectId = data
      },
      set_scanType(state, data) {
        state.scanType = data
      }
    },
    actions:{
      setIsOnline({ commit },data) {
        commit('set_isOnline',data);
      },
      setYdjClient({ commit },data) {
        commit('set_ydjClient',data);
      },
      setStandardAnswer({ commit },data) {
        commit('set_standardAnswer',data);
      },
      setTestPaperList({ commit },data) {
        commit('set_testPaperList',data);
      },
      setIsContinue({ commit },data) {
        commit('set_isContinue',data);
      },
      setIsCover({ commit },data) {
        commit('set_isCover',data);
      },
      setCoverData({ commit },data) {
        commit('set_coverData',data);
      },
    }
  };
  